if (!customElements.get('product-v2-size-guide')) {
  customElements.define(
    'product-v2-size-guide',
    class ProductV2SizeGuide extends HTMLElement {
      constructor() {
        super();
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
      }

      connectedCallback() {
        this.toggleBtn = this.querySelector('.product-v2-size-guide__dropdown-toggle');
        this.listbox = this.querySelector('.product-v2-size-guide__dropdown-list');
        this.valueEl = this.querySelector('[data-size-guide-value]');
        this.panels = this.querySelectorAll('[data-size-guide-panel]');
        this.options = this.querySelectorAll('[data-size-guide-option]');
        this.overlay = this.getOverlay();

        this.addEventListener('click', this.onClick);
        this.overlay?.addEventListener('click', this.onOverlayClick);
        this.normalizeTables();
      }

      normalizeTables() {
        this.querySelectorAll('.product-v2-size-guide__table-panel table').forEach((table) => {
          table.removeAttribute('border');
          table.style.border = '0';
          table.style.boxShadow = 'none';

          table.querySelectorAll('th, td, tr, thead, tbody').forEach((cell) => {
            cell.removeAttribute('border');
            cell.style.border = '0';
            cell.style.borderWidth = '0';
            cell.style.borderStyle = 'none';
            cell.style.boxShadow = 'none';
          });
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.overlay?.removeEventListener('click', this.onOverlayClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
      }

      getOverlay() {
        const overlayId = this.dataset.overlayId;
        if (!overlayId) return null;

        return document.getElementById(overlayId);
      }

      open() {
        if (this.hasAttribute('hidden')) {
          this.removeAttribute('hidden');
        }

        if (this.overlay?.hasAttribute('hidden')) {
          this.overlay.removeAttribute('hidden');
        }

        document.body.classList.add('product-v2-size-guide-open');
        document.addEventListener('keydown', this.onDocumentKeydown);

        requestAnimationFrame(() => {
          this.classList.add('is-open');
          this.overlay?.classList.add('is-visible');
          this.querySelector('.product-v2-size-guide__panel')?.focus();
        });
      }

      close() {
        this.classList.remove('is-open');
        this.overlay?.classList.remove('is-visible');
        this.closeDropdown();
        document.body.classList.remove('product-v2-size-guide-open');
        document.removeEventListener('keydown', this.onDocumentKeydown);

        window.setTimeout(() => {
          if (!this.classList.contains('is-open')) {
            this.setAttribute('hidden', '');
            this.overlay?.setAttribute('hidden', '');
          }
        }, 450);
      }

      onOverlayClick(event) {
        if (event.target !== this.overlay) return;
        this.close();
      }

      onDocumentKeydown(event) {
        if (event.key === 'Escape') {
          if (this.isDropdownOpen()) {
            this.closeDropdown();
            return;
          }
          this.close();
        }
      }

      onClick(event) {
        if (event.target.closest('[data-size-guide-close]')) {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.target.closest('.product-v2-size-guide__dropdown-toggle')) {
          event.preventDefault();
          this.toggleDropdown();
          return;
        }

        const optionBtn = event.target.closest('[data-size-guide-option] button');
        if (optionBtn) {
          event.preventDefault();
          const option = optionBtn.closest('[data-size-guide-option]');
          this.selectOption(option);
        }
      }

      isDropdownOpen() {
        return this.toggleBtn?.getAttribute('aria-expanded') === 'true';
      }

      toggleDropdown() {
        if (this.isDropdownOpen()) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      openDropdown() {
        if (!this.toggleBtn || !this.listbox) return;

        this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.listbox.hidden = false;
        this.classList.add('is-dropdown-open');
      }

      closeDropdown() {
        if (!this.toggleBtn || !this.listbox) return;

        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.listbox.hidden = true;
        this.classList.remove('is-dropdown-open');
      }

      selectOption(option) {
        if (!option) return;

        const index = option.dataset.index;
        const label = option.querySelector('button')?.textContent?.trim();
        if (label && this.valueEl) {
          this.valueEl.textContent = label;
        }

        this.options.forEach((item) => {
          const isSelected = item === option;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-selected', String(isSelected));
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.index === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        this.closeDropdown();
      }

      static openFromTrigger(trigger) {
        const productRoot = trigger.closest('product-v2');
        const sizeGuide = productRoot?.querySelector('product-v2-size-guide');

        if (!sizeGuide) return;

        if (typeof sizeGuide.open === 'function') {
          sizeGuide.open();
          return;
        }

        customElements.whenDefined('product-v2-size-guide').then(() => {
          productRoot?.querySelector('product-v2-size-guide')?.open?.();
        });
      }
    }
  );
}

if (!window.__productV2SizeGuideTriggerBound) {
  window.__productV2SizeGuideTriggerBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-size-guide-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    customElements.get('product-v2-size-guide')?.openFromTrigger(trigger);
  });
}
